<template>
  <div>
    <el-select ref="select" @focus="clear" @hook:mounted="clear" @visible-change="clear" @blur.native.capture="onblur" :popper-append-to-body="false" :filterable="true" :remote="true" :remote-method="handleRemote" :value="value" value-key="id" :size="size" :placeholder="$t('card.kind')" v-el-select-loadmore="loadMore" @input="change($event)" :clearable="true">
      <el-option label="----------" :value="emptyValue" />
      <el-option :teleported="false" v-for="item in options" :key="item.id" :label="item.name" :value="item" />
    </el-select>
    <el-button v-if="config && config.update" @click="handleUpdate" >{{ $t('table.update') }}</el-button>
  </div>
</template>

<script>

import {fetchCardKindList} from '../api/card-kind'
import {debounce} from '../../utils'

export default {
  data () {
    return {
      emptyValue: { id: 0 },
      options: [],
      serach: [],
      res: [],
      isSerach: false,
      formData: {
        pageIndex: 1,
        pageSize: 10,
        serachPageIndex: 1,
        serachPageSize: 20
      }
    }
  },
  created () {
    if (this.value) {
      this.handleRemote(this.value.name)
    } else {
      this.handleUpdate()
    }
  },
  props: ['value', 'placeholder', 'config', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    clear (async) {
      this.dropDownValue = ''
      this.$nextTick(() => {
        if (!async) {
          // ios 手机有延迟问题
          setTimeout(() => {
            const { select } = this.$refs
            const input = select.$el.querySelector('.el-input__inner')
            input.removeAttribute('readonly')
          }, 200)
        }
      })
    },
    // 失去焦点时，需要把软键盘收起
    onblur () {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { // 判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur()
        }
      })
    },
    handleRemote (data) {
      debounce(() => {
        this.dropDownValue = data
        this.options = []
        // 重置搜索分页参数
        this.formData.serachPageIndex = 1 // 新增重置页码
        this.handleUpdate(false)
      }, 500, true)()
    },
    change: function (val) {
      this.$emit('input', val)
    },
    handleUpdate (loadMore = false) {
      // 非加载更多时重置页码
      if (!loadMore) {
        if (this.dropDownValue) {
          this.formData.serachPageIndex = 1 // 强制重置为第一页
        } else {
          this.formData.pageIndex = 1
        }
        this.options = [] // 清空旧数据
      }

      // 动态计算当前页码（关键修改）
      const isSearch = !!this.dropDownValue
      let currentPage
      if (isSearch) {
        currentPage = loadMore ? ++this.formData.serachPageIndex : this.formData.serachPageIndex
      } else {
        currentPage = loadMore ? ++this.formData.pageIndex : this.formData.pageIndex
      }

      // 构造请求参数
      const query = {
        limit: isSearch ? this.formData.serachPageSize : this.formData.pageSize,
        page: currentPage,
        o: 'id,desc'
      }

      // 添加搜索条件（确保条件格式正确）
      if (isSearch) {
        query.q = `like,name,%${this.dropDownValue}%` // 标准化查询格式
      }

      // 发起请求
      fetchCardKindList(query).then(res => {
        const newData = res.data.map(item => ({ ...item, id: parseInt(item.id) }))
        this.options = loadMore ? [...this.options, ...newData] : newData
      })
    },
    loadMore () {
      this.handleUpdate(true)
    }
  },
  watch: {
    value: {
      handler (newVal) {
        if (newVal && newVal.name) {
          this.handleRemote(newVal.name)
        }
      },
      immediate: false,
      deep: true
    }
  },
  directives: {
    'el-select-loadmore': {
      bind (el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition && this.scrollTop !== 0) {
            binding.value()
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/CardKindSelect.vue